<template>
  <div class="settlement-bill">
    <el-form :inline="true" :model="searchForm" ref="searchForm" :show-message="false">
      <el-form-item prop="periodRange" label="结算账期">
        <el-date-picker
          v-model="searchForm.periodRange"
          type="monthrange"
          value-format="yyyy-MM"
          start-placeholder="开始账期"
          end-placeholder="结束账期"
        />
      </el-form-item>
      <el-form-item prop="cityCode" label="城市" required>
        <el-select filterable v-model="searchForm.cityCode" @change="getSupplierList">
          <el-option
            v-for="item in citiesInfo"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="supplierId" label="供应商名称" required>
        <el-select filterable v-model="searchForm.supplierId" :disabled="!searchForm.cityCode">
          <el-option
            v-for="item in supplierList"
            :label="item.supplierName"
            :value="item.supplierId"
            :key="item.supplierId"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="bizLine" label="业务线" required>
        <el-select :clearable="false" v-model="searchForm.bizLine">
          <el-option
            v-for="item in commonOptionList.businessTypeList"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="orderId" label="对账单编号">
        <el-input
          :maxLength="32"
          clearable
          v-model.trim="searchForm.orderId"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item prop="orderStatusId" label="对账单状态">
        <el-select clearable v-model="searchForm.orderStatusId">
          <el-option
            v-for="item in statusList"
            :label="item.statusName"
            :value="item.statusId"
            :key="item.statusId"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="orderPayWay" label="对账单类别">
        <el-select clearable v-model="searchForm.orderPayWay" @change="onOrderPayWayChange">
          <el-option label="正常结算" :value="0" />
          <el-option label="提前付款" :value="1" />
          <el-option label="专员结算" :value="2" />
          <el-option label="个人报销已付款" :value="8" />
        </el-select>
      </el-form-item>
      <el-form-item prop="createTimeRange" label="生成时间">
        <el-date-picker
          v-model="searchForm.createTimeRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="fetchList(true)"
          :loading="isLoading"
          :disabled="!this.searchForm.cityCode || !this.searchForm.supplierId"
          >搜索</el-button
        >
        <el-button @click="resetSearchForm">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="ui-card ui-card-body">
      <el-table v-loading="isLoading" :data="dataList">
        <el-table-column label="对账单编号" prop="settlementOrderNo" width="140" />
        <el-table-column label="供应商名称" prop="supplier" />
        <el-table-column label="结算账期" prop="costPeriodStart" width="80" />
        <el-table-column label="城市" prop="cityName" />
        <el-table-column label="Region Name" prop="regionName" width="100" />
        <el-table-column label="生成时间" width="150">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate('yyyy-MM-dd HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column label="对账单状态" prop="orderStatusName" width="120" />
        <el-table-column label="账单总金额" prop="totalCost" width="110" />
        <el-table-column label="对账单类别" prop="orderPayWayName" width="120" />
        <el-table-column label="操作" width="110">
          <template slot-scope="scope">
            <router-link
              target="_blank"
              :to="{
                name: '/srm/settlement-bill-detail',
                query: { id: scope.row.settlementOrderNo },
              }"
            >
              <el-button type="text">对账单详情</el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging-wrapper" v-if="totalPages > 1">
        <el-pagination
          @current-change="handlePageNoChange"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          layout="prev, pager, next, slot, jumper"
          :total="totalAmount"
        >
          <span class="page-indicator"
            ><em>{{ pageNo }}</em
            >/{{ totalPages }}</span
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  commonOpt as commonOptionList,
  pagination,
  filtersFormatDate,
  computedCitiesInfo,
} from '@/mixins'

const labelChina = '中国'
export default {
  mixins: [commonOptionList, pagination, filtersFormatDate, computedCitiesInfo],

  data() {
    return {
      isLoading: false,
      supplierList: [],
      statusList: [],
      dataList: [],
      searchForm: {
        createTimeRange: [],
        periodRange: [],
        supplierId: '',
        periodSt: '',
        periodEd: '',
        cityCode: '',
        orderId: '',
        createTimeSt: '',
        createTimeEd: '',
        bizLine: 1204,
        orderStatusId: '',
        orderPayWay: '',
      },
    }
  },

  created() {
    this.searchForm.cityCode = this.$store.state.currentCity
    this.getSupplierList()
    this.getStatusList()
    this.initPagination('fetchList', false)
    if (process.env.NODE_ENV === 'development') {
      this.searchForm.cityCode = '010'
      this.searchForm.supplierId = '2690'
    }
  },

  computed: {
    citiesInfo() {
      return this.searchForm.orderPayWay === 2
        ? [{ label: labelChina, value: labelChina }]
        : this.$store.state.citiesInfo
    },
  },

  methods: {
    resetSearchForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm.supplierId = this.supplierList[0] && this.supplierList[0].supplierId
    },

    // 对账单类别变更
    onOrderPayWayChange() {
      // https://km.sankuai.com/page/399675228
      // 当选择“对账单类别”为“专员结算”时，城市无需进行填写，默认为“中国”
      if (this.searchForm.orderPayWay === 2) {
        this.searchForm.cityCode = labelChina
        this.getSupplierList()
      }
    },

    // 列表
    fetchList(init = false) {
      if (this.searchForm.bizLine === 1203) {
        return this.$message.error('无电单车业务线权限')
      }
      if (init) this.pageNo = 1
      const params = {
        ...this.searchForm,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      params.periodRange = params.periodRange || []
      params.createTimeRange = params.createTimeRange || []
      params.periodSt = params.periodRange[0] || ''
      params.periodEd = params.periodRange[1] || ''
      params.createTimeSt = params.createTimeRange[0] || ''
      params.createTimeEd = params.createTimeRange[1] || ''
      delete params.periodRange
      delete params.createTimeRange
      this.isLoading = true
      this.fetch
        .post('srm_settlementOrderList', params)
        .then(res => {
          this.isLoading = false
          const data = res.data || {}
          this.dataList = data.lists || []
          this.totalAmount = data.count || 0
        })
        .catch(() => {
          this.isLoading = false
        })
    },

    // 获取状态列表
    getStatusList() {
      this.fetch
        .get('srm_settlementOrderStatus')
        .then(res => {
          const data = res.data || {}
          this.statusList = data.statusList || []
        })
        .catch(() => {})
    },

    // 获取供应商列表
    getSupplierList() {
      const params = {
        cityCode: this.searchForm.cityCode,
      }
      if (!params.cityCode) return
      this.fetch
        .get('srm_settlementQuerySuppliers', { params })
        .then(res => {
          this.supplierList = res.data || []
          this.searchForm.supplierId = this.supplierList[0] && this.supplierList[0].supplierId
        })
        .catch(() => {
          this.supplierList = []
          this.searchForm.supplierId = ''
        })
    },
  },
}
</script>
